import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Training Certificate Template Configuration")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Organization Type", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute", -1)
const _hoisted_15 = { class: "col-md-2 mt-9" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "" }, null, -1)
const _hoisted_17 = { class: "col-md-2 mt-9" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "" }, null, -1)
const _hoisted_19 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#employee_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Training Partner Certificate Information")
  ])
], -1)
const _hoisted_21 = {
  id: "employee_information",
  class: "collapse show"
}
const _hoisted_22 = { class: "collapse show" }
const _hoisted_23 = { class: "card-body border-top p-5" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-md-3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Right Signatory", -1)
const _hoisted_27 = { class: "col-sm-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Upload Right Signature", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = { class: "col-md-2 mt-9" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "" }, null, -1)
const _hoisted_32 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#employee_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, " Institute Certificate Information")
  ])
], -1)
const _hoisted_34 = {
  id: "employee_information",
  class: "collapse show"
}
const _hoisted_35 = { class: "collapse show" }
const _hoisted_36 = { class: "card-body border-top p-5" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-md-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Left Signatory", -1)
const _hoisted_40 = { class: "col-sm-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Upload Left Signature", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = { class: "col-md-2 mt-9" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "" }, null, -1)
const _hoisted_45 = { key: 2 }
const _hoisted_46 = { class: "card mb-5 mb-xl-10" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#description",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Training Certificate Preview")
  ])
], -1)
const _hoisted_48 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_49 = { class: "collapse show" }
const _hoisted_50 = { class: "card-body border-top p-6" }
const _hoisted_51 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_52 = { class: "card mb-5 mb-xl-10" }
const _hoisted_53 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_54 = { class: "collapse show" }
const _hoisted_55 = { class: "card-body border-top" }
const _hoisted_56 = { class: "logo" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("img", {
  style: {"float":"left","margin-left":"87px","margin-top":"69px","height":"62px","width":"133px"},
  src: "https://seeklogo.com/images/S/seip-skills-for-employment-investment-program-logo-57AF59698D-seeklogo.com.png",
  alt: "Logo 1"
}, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-left":"22%","margin-top":"69px","height":"58px","width":"120px","float":"left"},
  src: "https://cdn.worldvectorlogo.com/logos/bangladesh-govt-logo-vector.svg",
  alt: "Logo 1"
}, null, -1)
const _hoisted_59 = { style: {"float":"left","margin-left":"-479px","margin-top":"156px"} }
const _hoisted_60 = ["src"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "certificate-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box" }, [
    /*#__PURE__*/_createElementVNode("p", {
      class: "center",
      style: {"font-famly":"Olde-English"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "h3 negrito-2 serif text-uppercase" }, "Certificate in "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("span", { class: "serif h3" }, " -------------------------------------------------------------------- "),
      /*#__PURE__*/_createTextVNode(),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("p", {
        class: "esquerda",
        style: {"text-align":"center"}
      }, [
        /*#__PURE__*/_createElementVNode("span", { class: "h3 negrito-2 serif text-uppercase" }, "is awarded to"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("span", { class: "serif h3" }, " -------------------------------------------------------------------- ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      style: {"text-align":"justify"},
      class: "serif pt-3"
    }, [
      /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify"} }, [
        /*#__PURE__*/_createTextVNode(" Son/Daughter of "),
        /*#__PURE__*/_createElementVNode("span", { class: "negrito" }, "--------------------------------"),
        /*#__PURE__*/_createTextVNode(" and "),
        /*#__PURE__*/_createElementVNode("span", { class: "negrito" }, "-------------------------------- "),
        /*#__PURE__*/_createTextVNode(" for having achieved the units of competency through training program "),
        /*#__PURE__*/_createElementVNode("span", { class: "negrito" }, " ------------------ "),
        /*#__PURE__*/_createTextVNode(" hours held from "),
        /*#__PURE__*/_createElementVNode("span", { class: "negrito" }, "-------------------- "),
        /*#__PURE__*/_createTextVNode(" to "),
        /*#__PURE__*/_createElementVNode("span", { class: "negrito" }, " ----------------------- "),
        /*#__PURE__*/_createTextVNode(" at "),
        /*#__PURE__*/_createElementVNode("span", { class: "negrito" }, " -------------------------------------------------------------------- "),
        /*#__PURE__*/_createTextVNode(" supported by the Skills for Employment Investment Program (SEIP), Finance Division, Ministry Of Finance, Government of Bangladesh. ")
      ])
    ])
  ])
], -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20%"} }, null, -1)
const _hoisted_63 = {
  class: "d-flex justify-content-between",
  style: {"width":"90%","margin":"0 auto"}
}
const _hoisted_64 = {
  key: 0,
  style: {"width":"17%"}
}
const _hoisted_65 = ["src"]
const _hoisted_66 = { style: {"width":"80px","height":"80px"} }
const _hoisted_67 = {
  key: 1,
  style: {"width":"17%"}
}
const _hoisted_68 = ["src"]
const _hoisted_69 = { class: "logo" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("img", {
  style: {"float":"left","margin-left":"87px","margin-top":"69px","height":"62px","width":"133px"},
  src: "https://seeklogo.com/images/S/seip-skills-for-employment-investment-program-logo-57AF59698D-seeklogo.com.png",
  alt: "Logo 1"
}, null, -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-left":"22%","margin-top":"69px","height":"58px","width":"120px","float":"left"},
  src: "https://cdn.worldvectorlogo.com/logos/bangladesh-govt-logo-vector.svg",
  alt: "Logo 1"
}, null, -1)
const _hoisted_72 = { style: {"float":"left","margin-left":"-479px","margin-top":"156px"} }
const _hoisted_73 = ["src"]
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "certificate-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box" }, [
    /*#__PURE__*/_createElementVNode("p", {
      class: "center",
      style: {"font-famly":"Olde-English"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "h3 negrito-2 serif text-uppercase" }, "Certificate in "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("span", { class: "serif h3" }, " -------------------------------------------------------------------- "),
      /*#__PURE__*/_createTextVNode(),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("p", {
        class: "esquerda",
        style: {"text-align":"center"}
      }, [
        /*#__PURE__*/_createElementVNode("span", { class: "h3 negrito-2 serif text-uppercase" }, "is awarded to"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("span", { class: "serif h3" }, " -------------------------------------------------------------------- ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      style: {"text-align":"justify"},
      class: "serif pt-3"
    }, [
      /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify"} }, [
        /*#__PURE__*/_createTextVNode(" Son/Daughter of "),
        /*#__PURE__*/_createElementVNode("span", { class: "negrito" }, "--------------------------------"),
        /*#__PURE__*/_createTextVNode(" and "),
        /*#__PURE__*/_createElementVNode("span", { class: "negrito" }, "-------------------------------- "),
        /*#__PURE__*/_createTextVNode(" for having achieved the units of competency through training program "),
        /*#__PURE__*/_createElementVNode("span", { class: "negrito" }, " ------------------ "),
        /*#__PURE__*/_createTextVNode(" hours held from "),
        /*#__PURE__*/_createElementVNode("span", { class: "negrito" }, "-------------------- "),
        /*#__PURE__*/_createTextVNode(" to "),
        /*#__PURE__*/_createElementVNode("span", { class: "negrito" }, " ----------------------- "),
        /*#__PURE__*/_createTextVNode(" at "),
        /*#__PURE__*/_createElementVNode("span", { class: "negrito" }, " -------------------------------------------------------------------- "),
        /*#__PURE__*/_createTextVNode(" supported by the Skills for Employment Investment Program (SEIP), Finance Division, Ministry Of Finance, Government of Bangladesh. ")
      ])
    ])
  ])
], -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20%"} }, null, -1)
const _hoisted_76 = {
  class: "d-flex justify-content-between",
  style: {"width":"90%","margin":"0 auto"}
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"17%"} }, [
  /*#__PURE__*/_createElementVNode("p", null, " Signatute Image(Institute)"),
  /*#__PURE__*/_createElementVNode("p", null, "Left Signature")
], -1)
const _hoisted_78 = { style: {"width":"80px","height":"80px"} }
const _hoisted_79 = {
  key: 0,
  style: {"width":"17%"}
}
const _hoisted_80 = ["src"]
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 auto"} }, [
  /*#__PURE__*/_createElementVNode("p", null, "Issued On 20 June 2023")
], -1)
const _hoisted_82 = {
  key: 0,
  class: "card"
}
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "card-header align-items-center bg-success border-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-light h3" }, "Template List")
  ])
], -1)
const _hoisted_84 = {
  key: 0,
  class: "card-body pt-4"
}
const _hoisted_85 = ["src"]
const _hoisted_86 = { key: 0 }
const _hoisted_87 = ["src"]
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { key: 1 }
const _hoisted_90 = { key: 0 }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = ["onClick"]
const _hoisted_93 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check text-light" }, null, -1)
const _hoisted_94 = [
  _hoisted_93
]
const _hoisted_95 = ["onClick"]
const _hoisted_96 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ban text-light" }, null, -1)
const _hoisted_97 = [
  _hoisted_96
]
const _hoisted_98 = ["onClick"]
const _hoisted_99 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-trash-alt" }, null, -1)
const _hoisted_100 = [
  _hoisted_99
]
const _hoisted_101 = ["onClick"]
const _hoisted_102 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-pencil-alt" }, null, -1)
const _hoisted_103 = [
  _hoisted_102
]
const _hoisted_104 = ["onClick"]
const _hoisted_105 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-eye" }, null, -1)
const _hoisted_106 = [
  _hoisted_105
]
const _hoisted_107 = {
  key: 1,
  class: "card-body pt-4"
}
const _hoisted_108 = ["src"]
const _hoisted_109 = { key: 0 }
const _hoisted_110 = { key: 1 }
const _hoisted_111 = { key: 0 }
const _hoisted_112 = { key: 1 }
const _hoisted_113 = ["onClick"]
const _hoisted_114 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check text-light" }, null, -1)
const _hoisted_115 = [
  _hoisted_114
]
const _hoisted_116 = ["onClick"]
const _hoisted_117 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ban text-light" }, null, -1)
const _hoisted_118 = [
  _hoisted_117
]
const _hoisted_119 = ["onClick"]
const _hoisted_120 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-trash-alt" }, null, -1)
const _hoisted_121 = [
  _hoisted_120
]
const _hoisted_122 = ["onClick"]
const _hoisted_123 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-pencil-alt" }, null, -1)
const _hoisted_124 = [
  _hoisted_123
]
const _hoisted_125 = ["onClick"]
const _hoisted_126 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-eye" }, null, -1)
const _hoisted_127 = [
  _hoisted_126
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_CertificateEditModal = _resolveComponent("CertificateEditModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_component_Form, {
      class: "form",
      "validation-schema": _ctx.AssociationSchema
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _hoisted_10,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Training Type",
                        modelValue: _ctx.type,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.type) = $event)),
                        style: {"width":"100%"},
                        onChange: _ctx.btnCheckStatus
                      }, {
                        default: _withCtx(() => [
                          (_ctx.is_seip_user == true || _ctx.is_entity_user == true)
                            ? (_openBlock(), _createBlock(_component_el_option, {
                                key: 0,
                                value: "Training Partner"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Training Partner")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.is_seip_user == true || _ctx.is_institute_user == true)
                            ? (_openBlock(), _createBlock(_component_el_option, {
                                key: 1,
                                value: "Training Institute"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Training Institute")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    (_ctx.btnCheck)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _hoisted_12,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Partner",
                            modelValue: _ctx.batch.entity_id,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                            filterable: "",
                            style: {"width":"100%"},
                            onChange: _ctx.getTrainingInstitute
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.association, (data) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: data.id,
                                  label: '[' + data.entity_short_name + '] - ' + data.entity_name
                                            ,
                                  value: data.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString('[' + data.entity_short_name + '] - ' + data.entity_name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "entity_id",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.instituteCheck)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _hoisted_14,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Institute",
                            modelValue: _ctx.batch.institute_id,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.institute_id) = $event)),
                            name: "institute_id",
                            filterable: "",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (info) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: info.id,
                                  label: info.institute_name,
                                  value: info.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(info.institute_name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("button", {
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.allForm && _ctx.allForm(...args))),
                        type: "button",
                        class: "btn btn-success p-3",
                        style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                      }, [
                        _createTextVNode(" Next"),
                        _hoisted_16
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("button", {
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.allTemplate && _ctx.allTemplate(...args))),
                        type: "button",
                        class: "btn btn-success p-3",
                        style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                      }, [
                        _createTextVNode(" See All Template"),
                        _hoisted_18
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        (this.showFormEntity)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.right) = $event)),
                          type: "text",
                          placeholder: "Right Signatory",
                          name: "",
                          class: "form-control"
                        }, null, 512), [
                          [_vModelText, _ctx.right]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _hoisted_29,
                        _createElementVNode("input", {
                          type: "file",
                          ref: "rightFileInput",
                          class: "form-control",
                          onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onRightChange && _ctx.onRightChange(...args))),
                          style: {"width":"100%"}
                        }, null, 544)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("button", {
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.formSubmit && _ctx.formSubmit(...args))),
                          type: "button",
                          class: "btn btn-success p-3",
                          style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                        }, [
                          _createTextVNode(" Save & Preview "),
                          _hoisted_31
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (this.showFormTI)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _hoisted_39,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.left) = $event)),
                          type: "text",
                          name: "",
                          placeholder: "Left Signatory",
                          class: "form-control"
                        }, null, 512), [
                          [_vModelText, _ctx.left]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _hoisted_41,
                        _hoisted_42,
                        _createElementVNode("input", {
                          type: "file",
                          ref: "leftFileInput",
                          class: "form-control",
                          onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onLeftChange && _ctx.onLeftChange(...args))),
                          style: {"width":"100%"}
                        }, null, 544)
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("button", {
                          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.formSubmit && _ctx.formSubmit(...args))),
                          type: "button",
                          class: "btn btn-success p-3",
                          style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                        }, [
                          _createTextVNode(" Save & Preview "),
                          _hoisted_44
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDataTable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, [
                                (_ctx.type == 'Training Institute')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      style: _normalizeStyle({ 'background-image': 'url(' + this.VUE_APP_API_URL + '/storage/images/CertificateBackground/ttt.gif' + ')', 'background-repeat': 'no-repeat' }),
                                      class: "certificate"
                                    }, [
                                      _createElementVNode("div", _hoisted_56, [
                                        _hoisted_57,
                                        _hoisted_58,
                                        _createElementVNode("h3", _hoisted_59, " Registration No : " + _toDisplayString(_ctx.registration_number), 1),
                                        _createElementVNode("img", {
                                          style: {"float":"right","margin-right":"85px","margin-top":"70px","height":"81px","width":"137px"},
                                          src: `${this.VUE_APP_API_URL}${_ctx.entityInfos[0]?.file_path}`,
                                          alt: "Logo 2"
                                        }, null, 8, _hoisted_60)
                                      ]),
                                      _hoisted_61,
                                      _hoisted_62,
                                      _createElementVNode("div", _hoisted_63, [
                                        (_ctx.BackgroundInfos.left)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                              _createElementVNode("p", null, [
                                                (_ctx.BackgroundInfos.left?.[0]?.left_signature)
                                                  ? (_openBlock(), _createElementBlock("img", {
                                                      key: 0,
                                                      style: {"height":"50px","width":"100px"},
                                                      src: `${this.VUE_APP_API_URL}${_ctx.BackgroundInfos.left?.[0]?.left_signature}`,
                                                      alt: "Logo 2"
                                                    }, null, 8, _hoisted_65))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("p", null, _toDisplayString(_ctx.BackgroundInfos.left?.[0]?.left_signatory), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_66, [
                                          _createVNode(_component_qrcode_vue, { value: _ctx.qrData }, null, 8, ["value"])
                                        ]),
                                        (_ctx.BackgroundInfos.right)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                              _createElementVNode("p", null, [
                                                (_ctx.BackgroundInfos.right?.[0]?.right_signature)
                                                  ? (_openBlock(), _createElementBlock("img", {
                                                      key: 0,
                                                      style: {"height":"50px","width":"100px"},
                                                      src: `${this.VUE_APP_API_URL}${_ctx.BackgroundInfos.right?.[0]?.right_signature}`,
                                                      alt: "Logo 2"
                                                    }, null, 8, _hoisted_68))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("p", null, _toDisplayString(_ctx.BackgroundInfos.right?.[0]?.right_signatory), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ], 4))
                                  : _createCommentVNode("", true),
                                (_ctx.type == 'Training Partner')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      style: _normalizeStyle({ 'background-image': 'url(' + this.VUE_APP_API_URL + '/storage/images/CertificateBackground/ttt.gif' + ')', 'background-repeat': 'no-repeat' }),
                                      class: "certificate"
                                    }, [
                                      _createElementVNode("div", _hoisted_69, [
                                        _hoisted_70,
                                        _hoisted_71,
                                        _createElementVNode("h3", _hoisted_72, " Registration No : " + _toDisplayString(_ctx.registration_number), 1),
                                        _createElementVNode("img", {
                                          style: {"float":"right","margin-right":"85px","margin-top":"70px","height":"81px","width":"137px"},
                                          src: `${this.VUE_APP_API_URL}${_ctx.entityInfos[0]?.file_path}`,
                                          alt: "Logo 2"
                                        }, null, 8, _hoisted_73)
                                      ]),
                                      _hoisted_74,
                                      _hoisted_75,
                                      _createElementVNode("div", _hoisted_76, [
                                        _hoisted_77,
                                        _createElementVNode("div", _hoisted_78, [
                                          _createVNode(_component_qrcode_vue, { value: _ctx.qrData }, null, 8, ["value"])
                                        ]),
                                        (_ctx.BackgroundInfos.right)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                              _createElementVNode("p", null, [
                                                (_ctx.BackgroundInfos.right?.[0]?.right_signature)
                                                  ? (_openBlock(), _createElementBlock("img", {
                                                      key: 0,
                                                      style: {"height":"50px","width":"100px"},
                                                      src: `${this.VUE_APP_API_URL}${_ctx.BackgroundInfos.right?.[0]?.right_signature}`,
                                                      alt: "Logo 2"
                                                    }, null, 8, _hoisted_80))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("p", null, _toDisplayString(_ctx.BackgroundInfos.right?.[0]?.right_signatory), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ], 4))
                                  : _createCommentVNode("", true),
                                _hoisted_81
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["validation-schema"])), [
      [_directive_loading, _ctx.loading]
    ]),
    (_ctx.showTable)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_82, [
          _hoisted_83,
          (_ctx.type =='Training Institute')
            ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                (_openBlock(), _createBlock(_component_Datatable, {
                  "table-data": _ctx.Infos,
                  "table-header": _ctx.tableHeader,
                  key: _ctx.componentKey
                }, {
                  "cell-photo": _withCtx(({ row: Infos }) => [
                    (Infos?.left_signature)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          style: {"width":"50px","height":"50px"},
                          src: `${this.VUE_APP_API_URL}${Infos?.left_signature}`,
                          alt: ""
                        }, null, 8, _hoisted_85))
                      : _createCommentVNode("", true)
                  ]),
                  "cell-left": _withCtx(({ row: Infos }) => [
                    (Infos?.left_signatory)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_86, _toDisplayString(Infos?.left_signatory), 1))
                      : _createCommentVNode("", true)
                  ]),
                  "cell-right-photo": _withCtx(({ row: Infos }) => [
                    (_ctx.rightInfos[0]?.right_signature)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          style: {"width":"50px","height":"50px"},
                          src: `${this.VUE_APP_API_URL}${_ctx.rightInfos[0]?.right_signature}`
                        }, null, 8, _hoisted_87))
                      : _createCommentVNode("", true)
                  ]),
                  "cell-right": _withCtx(({ row: Infos }) => [
                    (_ctx.rightInfos[0]?.right_signatory)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_88, _toDisplayString(_ctx.rightInfos[0]?.right_signatory), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_89, "Contact Training Partner For Right Signatory"))
                  ]),
                  "cell-status": _withCtx(({ row: Infos }) => [
                    (Infos.active_status == 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_90, "Active"))
                      : _createCommentVNode("", true),
                    (Infos.active_status == 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_91, "Inactive"))
                      : _createCommentVNode("", true)
                  ]),
                  "cell-actions": _withCtx(({ row: Infos }) => [
                    (Infos.active_status != 1
                        )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.Active(Infos.id)),
                          title: "Active",
                          class: "btn btn-icon btn-bg-success btn-active-color-success btn-sm me-1"
                        }, _hoisted_94, 8, _hoisted_92))
                      : _createCommentVNode("", true),
                    (Infos.active_status == 1
                        )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: ($event: any) => (_ctx.Inactive(Infos.id)),
                          title: "Inactive",
                          class: "btn btn-icon btn-bg-success btn-active-color-success btn-sm me-1"
                        }, _hoisted_97, 8, _hoisted_95))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.Delete(Infos.id)),
                      title: "Delete",
                      class: "btn btn-icon btn-bg-danger btn-active-color-primary btn-sm me-1"
                    }, _hoisted_100, 8, _hoisted_98),
                    ((Infos?.id !== null))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          "data-kt-drawer-toggle": "true",
                          "data-kt-drawer-target": "#kt_drawer_certificate_update",
                          onClick: ($event: any) => (_ctx.edit(Infos)),
                          id: "kt_drawer_certificate_update_button",
                          title: "Edit",
                          class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                        }, _hoisted_103, 8, _hoisted_101))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.view(Infos.id)),
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#industry_details",
                      class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1"
                    }, _hoisted_106, 8, _hoisted_104)
                  ]),
                  _: 1
                }, 8, ["table-data", "table-header"]))
              ]))
            : _createCommentVNode("", true),
          (_ctx.type == 'Training Partner')
            ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                (_openBlock(), _createBlock(_component_Datatable, {
                  "table-data": _ctx.Infos,
                  "table-header": _ctx.tableHeaderentity,
                  key: _ctx.componentKey
                }, {
                  "cell-right-photo": _withCtx(({ row: Infos }) => [
                    (Infos?.right_signature)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          style: {"width":"50px","height":"50px"},
                          src: `${this.VUE_APP_API_URL}${Infos?.right_signature}`
                        }, null, 8, _hoisted_108))
                      : _createCommentVNode("", true)
                  ]),
                  "cell-right": _withCtx(({ row: Infos }) => [
                    (Infos?.right_signatory)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_109, _toDisplayString(Infos?.right_signatory), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_110, "Contact Training Partner For Right Signatory"))
                  ]),
                  "cell-status": _withCtx(({ row: Infos }) => [
                    (Infos.active_status == 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_111, "Active"))
                      : _createCommentVNode("", true),
                    (Infos.active_status == 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_112, "Inactive"))
                      : _createCommentVNode("", true)
                  ]),
                  "cell-actions": _withCtx(({ row: Infos }) => [
                    (Infos.active_status != 1
                            )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.Active(Infos.id)),
                          title: "Active",
                          class: "btn btn-icon btn-bg-success btn-active-color-success btn-sm me-1"
                        }, _hoisted_115, 8, _hoisted_113))
                      : _createCommentVNode("", true),
                    (Infos.active_status == 1
                            )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: ($event: any) => (_ctx.Inactive(Infos.id)),
                          title: "Inactive",
                          class: "btn btn-icon btn-bg-success btn-active-color-success btn-sm me-1"
                        }, _hoisted_118, 8, _hoisted_116))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.Delete(Infos.id)),
                      title: "Delete",
                      class: "btn btn-icon btn-bg-danger btn-active-color-primary btn-sm me-1"
                    }, _hoisted_121, 8, _hoisted_119),
                    ((Infos?.id !== null))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          "data-kt-drawer-toggle": "true",
                          "data-kt-drawer-target": "#kt_drawer_certificate_update",
                          onClick: ($event: any) => (_ctx.edit(Infos)),
                          id: "kt_drawer_certificate_update_button",
                          title: "Edit",
                          class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                        }, _hoisted_124, 8, _hoisted_122))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.view(Infos.id)),
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#industry_details",
                      class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1"
                    }, _hoisted_127, 8, _hoisted_125)
                  ]),
                  _: 1
                }, 8, ["table-data", "table-header"]))
              ]))
            : _createCommentVNode("", true)
        ])), [
          [_directive_loading, _ctx.loading]
        ])
      : _createCommentVNode("", true),
    _createVNode(_component_CertificateEditModal)
  ], 64))
}